Array.from =
  Array.from ||
  function<T>(input: ArrayLike<T>): Array<T> {
    const output: Array<T> = [];

    for (let index = 0; index < input.length; index++) {
      output.push(input[index]);
    }

    return output;
  };

// tslint:disable:no-any
Array.prototype.find =
  Array.prototype.find ||
  function find<T>(
    this: Array<any>,
    predicate: (value: any, index: number, obj: Array<any>) => value is T,
    thisArg?: any
  ): T | undefined {
    for (let index = 0; index < this.length; index++) {
      const item = this[index];

      if (predicate(item, index, this)) {
        return item;
      }
    }

    return undefined;
  };



// WEBPACK FOOTER //
// ./src/polyfills.ts